import React from 'react'
import PropTypes from 'prop-types'

const ContactInfo = ({ customer }) =>
  customer && (
    <>
      <div>{customer.mobile}</div>
      <div>{customer.email}</div>
    </>
  )

ContactInfo.propTypes = {
  customer: PropTypes.object,
}

ContactInfo.defaultProps = {
  customer: null,
}

export default ContactInfo
